export default "__VITE_ASSET__59c49460__"